import { InputNumber, InputNumberProps } from 'antd';
import { memo } from 'react';
import { uiStore } from 'stores/root_store';
import './style.css';

interface CustomInputNumberProps extends InputNumberProps<number> { }



function CustomInputNumber(props: CustomInputNumberProps) {
  let size = '';
  switch (props.size) {
    case 'small':
      size = `!py-0.5`;
      break;
    default:
      size = '';
  }
  return (
    <InputNumber
      {...props}
      controls={false}
      style={{ textAlignLast: 'end' }}
      // formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
      formatter={(value) => `${value}`.replace(/[^0-9]/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
      // parser={x => parseFloat(`${x}`.replace(/,/, '#').replace(/\./g, '').replace(/#/, '.'))}
      className={
        uiStore.theme.name +
        ' hover:!border-primary !shadow-none [&.ant-input-number-disabled]:!border-[#d9d9d9] !min-w-[100px] !rounded-sm focus:!shadow-none ' +
        size +
        `${props.addonAfter ? ' !rounded-r-none ' : ''}` +
        `${props.addonBefore ? ' !rounded-l-none ' : ''}` +
        props.className
      }
    />
  );
}

export default memo(CustomInputNumber);
